import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import PaymentReportingOptInPage from './component';
import paths from '@renter-hub/pathsManifest';
import { showModalNotification, showPageNotification } from '@common/actions/NotificationActions';
import { PAYMENT_REPORTING_OPT_IN_SUCCESS } from '@renter-hub/constants/notifications';

const mapStateToProps = (state, { fromDashboard }) => {
  const { dashboard } = state.payments.renter;
  const { firstName, lastName } = dashboard.renterProfile;
  const { addressInfo } = dashboard.rentTerms;
  const { transactions } = dashboard.paymentHistory;
  const hasPaymentHistory =
    transactions?.length > 0 &&
    transactions.some(
      (transaction) =>
        transaction.paymentCategory === 'rentPayment' &&
        (transaction.renterStatus === 'complete' || transaction.renterStatus === 'manual'),
    );
  const user = state.user;

  const { firstDueDate } = dashboard.rentTerms;
  const accountOpenDate = firstDueDate ? new Date(firstDueDate) : new Date();

  const accountOpenDateFormatted = {
    year: accountOpenDate.getUTCFullYear(),
    month: accountOpenDate.getUTCMonth() + 1,
    day: accountOpenDate.getUTCDate(),
  };

  const optInPayload = {
    rentTermsKey: dashboard.rentTerms.rentTermsKey,
    street: addressInfo.homeAddress,
    city: addressInfo.city,
    state: addressInfo.state,
    zip: addressInfo.zipCode,
    unit: addressInfo.unit ?? '',
    paymentDurationInMonths: dashboard.rentTerms.numberOfPayments ?? 0,
    accountOpenDate: accountOpenDateFormatted ?? { year: 0, month: 0, day: 0 },
    isFixedRentTerm: !!dashboard.rentTerms.monthToMonth,
  };

  return {
    fromDashboard,
    alreadyEnrolled: dashboard.paymentReporting?.optedIn,
    optInPayload,
    hasPaymentHistory,
    user,
    listingAlias: dashboard.listingAlias,
    firstName,
    lastName,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, fromDashboard }) => ({
  showSuccessNotification: () => dispatch(showPageNotification(PAYMENT_REPORTING_OPT_IN_SUCCESS)),
  showSuccessModal: () => dispatch(showModalNotification(PAYMENT_REPORTING_OPT_IN_SUCCESS)),
  continueToNextPage: () => {
    const nextPage = fromDashboard ? baseUrl : baseUrl + paths.paymentInfoPage;
    dispatch(push(nextPage));
  },
  goToDashboard: async () => {
    await dispatch(push(baseUrl));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentReportingOptInPage);
